import { render } from "./Cbhienrollmentpage.vue?vue&type=template&id=a9daf7d4&scoped=true"
import script from "./Cbhienrollmentpage.vue?vue&type=script&lang=js"
export * from "./Cbhienrollmentpage.vue?vue&type=script&lang=js"

import "./Cbhienrollmentpage.vue?vue&type=style&index=0&id=a9daf7d4&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9daf7d4"]])

export default __exports__